import React, { FC } from 'react';
import { Switch, Route, useRouteMatch } from 'react-router-dom';
import { Operations } from './Operations';
import { OperationDetails } from './OperationDetails';


export const OperationsRouter: FC = (props) => {

  const { path } = useRouteMatch();

  return (<Switch>
    <Route exact path={path}>
      <Operations/>
    </Route>
    <Route exact path={`${path}/:id`}>
      <OperationDetails/>
    </Route>
  </Switch>);
};
